import type {
  AdServerMetadata,
  AdServerMetadataContent,
} from 'types/adServerTypes'

const getAdServerMetadataContent = (
  adServerMetadata: AdServerMetadata,
  productId: string,
  metadataId?: string
): Record<string, never> | AdServerMetadataContent => {
  if (!metadataId) {
    return {}
  }

  const adServerMetadataContent: AdServerMetadataContent =
    adServerMetadata[productId]

  if (adServerMetadataContent?.metadataId === metadataId) {
    return adServerMetadataContent
  }

  return {}
}

export default getAdServerMetadataContent
